export default __webpack_public_path__ + "static/media/report.e0e1fe7b.png";